import { FC } from "react";
import _isNumber from "lodash/isNumber";

import { CompanyI } from "@/interfaces/strapi/collection-types";
import { clsxMerge, formatNumbers } from "shared/lib/helpers";
import { StrapiImage } from "@/components/base/cms/image";

interface CompanyCardPropsI {
  className?: string;
  company?: CompanyI;
}

interface CompanyCardInfoItemPropsI {
  label: string;
  value?: string | number;
}

const CompanyCardInfoItem: FC<CompanyCardInfoItemPropsI> = ({ label, value }) =>
  value && (
    <div className="flex flex-col gap-1.5">
      <span className="text-landing-pink-100 typography-body-3">{label}</span>
      <span className="text-[#666] typography-header-7">
        {_isNumber(value) ? formatNumbers(value) : value}
      </span>
    </div>
  );

export const CompanyCard: FC<CompanyCardPropsI> = ({ className, company }) =>
  company && (
    <div
      className={clsxMerge(
        "min-w-[350px] overflow-hidden rounded-xl shadow-landing-card",
        className
      )}
    >
      <div
        className={clsxMerge(
          "flex h-[200px] w-full lg:w-[370px]",
          "items-center justify-center px-7",
          "bg-gradient-to-r from-purple-500 to-pink-500"
        )}
      >
        <StrapiImage className="max-h-[100px]" image={company.logo_white} />
      </div>

      {company && (
        <div className="flex flex-col gap-[22px] bg-[rgba(255,255,255,0.6)] p-6 backdrop-blur-[10px]">
          <CompanyCardInfoItem
            label="Headquarters"
            value={company.headquarters}
          />

          <CompanyCardInfoItem label="Founded" value={company.founded_date} />

          <CompanyCardInfoItem label="Company size" value={company.size} />

          <CompanyCardInfoItem
            label="Headquarters"
            value={company.headquarters}
          />

          <CompanyCardInfoItem label="Industry" value={company.industry} />
        </div>
      )}
    </div>
  );
